import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PreloaderService } from "@core";
import { DataService } from "@core/bootstrap/data.service";
import { LanguagePipe } from "@shared/pipes/language.pipe";
import { SweetAlertService } from "@shared/services/sweet-alert.service";
import { InitialDeliveryPlatformAddComponent } from "./initial-delivery-platform-add/initial-delivery-platform-add.component";

@Component({
	selector: "app-initial-delivery-platform",
	templateUrl: "./initial-delivery-platform.component.html",
	styleUrls: ["./initial-delivery-platform.component.scss"],
})
export class InitialDeliveryPlatformComponent implements OnInit {
	@Input() supervision_data: any;
	@Input() able2add: any;
	@Input() able2edit: any;
	@Input() project_data: any;
	@Input() makeActionInitial: any;
	lang_key = localStorage.getItem("lang_key") || "en";
	group1List = [];
	selected_group1 = null;
	group2List = [];
	selected_group2 = null;
	searchKey = "";
	initial_delivery_platform = [];
	page_no = 1;
	page_size = 10;
	collection_size = 0;
	constructor(
		private spinner: PreloaderService,
		private ds: DataService,
		private sweetAlert: SweetAlertService,
		private lang: LanguagePipe,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.get_initial_delivery_platforms();
		this.getGroup1List();
	}
	getGroup1List() {
		let param = new FormData();
		param.append("search_key", "");
		param.append("lang_key", this.lang_key);
		this.ds.getActionByUrl(this.ds.formData2string(param), "lpgone").subscribe(
			(res) => {
				if (res.status) {
					this.group1List = res?.records;
				} else {
					this.group1List = [];
				}
			},
			(error) => {
				this.group1List = [];
				this.sweetAlert.errorToast(
					error && error.error && error.error.error
						? error.error.error
						: this.lang.transform("lang_internal_server_error"),
					2000
				);
			}
		);
	}

	getGroup2List() {
		let param = new FormData();
		param.append("search_key", "");
		param.append("lang_key", this.lang_key);
		param.append("platform_group1_code_system", this.selected_group1 || "");
		this.ds.getActionByUrl(this.ds.formData2string(param), "lpgtwo").subscribe(
			(res) => {
				if (res.status) {
					this.group2List = res?.records;
				} else {
					this.group2List = [];
				}
			},
			(error) => {
				this.group2List = [];
				this.sweetAlert.errorToast(
					error && error.error && error.error.error
						? error.error.error
						: this.lang.transform("lang_internal_server_error"),
					2000
				);
			}
		);
	}
	get_initial_delivery_platforms() {
		let param = new FormData();
		param.append("search_key", this.searchKey);
		param.append("projects_profile_id", this.project_data?.projects_profile_id);
		param.append(
			"projects_work_area_id",
			this.supervision_data?.projects_work_area_id
		);
		param.append("platform_group1_code_system", this.selected_group1 || "");
		param.append("platform_group2_code_system", this.selected_group2 || "");
		this.spinner.show();
		this.ds
			.getActionByUrl(
				this.ds.formData2string(param),
				`p/snag/initialplatformlist/${this.page_no}/${this.page_size}`
			)
			.subscribe(
				(res) => {
					this.spinner.hide();
					if (res.status) {
						this.initial_delivery_platform = res.records;
						this.collection_size = res.page?.total_records;
					} else {
						this.initial_delivery_platform = [];
						this.collection_size = 0;
					}
				},
				(err) => {
					this.spinner.hide();
					this.initial_delivery_platform = [];
					this.collection_size = 0;
				}
			);
	}

	createUpdateInitialDelivery() {
		this.dialog
			.open(InitialDeliveryPlatformAddComponent, {
				width: "700px",
				data: {
					projects_profile_id: this.project_data?.projects_profile_id,
					projects_work_area_id: this.supervision_data?.projects_work_area_id,
				},
			})
			.afterClosed()
			.subscribe((res) => {
				if (res) {
					this.get_initial_delivery_platforms();
				}
			});
	}

	deleteInitialDelivery(id) {
		this.sweetAlert
			.confirmMessage(
				this.lang.transform("lang_are_you_sure"),
				this.lang.transform("lang_yes")
			)
			.then((res) => {
				if (res?.isConfirmed) {
					this.spinner.show();
					this.ds
						.deleteActionByUrl(
							[id],
							`p/snag/initialplatformdelete/${this.project_data?.projects_profile_id}/${this.supervision_data?.projects_work_area_id}`
						)
						.subscribe(
							(res) => {
								this.spinner.hide();
								if (res.status) {
									this.sweetAlert.successToast(res.msg, 2000);
									this.get_initial_delivery_platforms();
								} else {
									this.sweetAlert.errorToast(res.message, 2000);
								}
							},
							(err) => {
								this.spinner.hide();
								this.sweetAlert.errorToast(
									err && err.error && err.error.error
										? err.error.error
										: this.lang.transform("lang_internal_server_error"),
									2000
								);
							}
						);
				}
			});
	}
}
